export default {
    apiKey: 'AIzaSyB5BNLLz7VQrQk3PWI-igJeslDY5EI_YAw',
    authDomain: 'fondazione-fe55b.firebaseapp.com',
    projectId: 'fondazione-fe55b',
    storageBucket: 'fondazione-fe55b.appspot.com',
    messagingSenderId: '1081506507717',
    appId: '1:1081506507717:web:050383fe5b35f26ae3f9ac',
    measurementId: 'G-TTBZ3FZ101',
};
